import React from 'react';
import '../../style/scss/tooltip.scss';

interface TooltipProps {
    children: React.ReactNode;
    position?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, position }) => {
    return (
        <div className={`tooltip ${position ? `tooltip-${position}` : ''}`}>
            {children}
        </div>
    );
};

export default Tooltip;